import React, { useEffect, useRef } from "react";
import { languageMap } from "./languageMap";
import { CodeView } from "@cloudscape-design/code-view";
import CopyToClipboard from "@cloudscape-design/components/copy-to-clipboard";

export const CodeBlock = React.memo(({ code, language, width = "95%" }) => {
  const codeBlockRef = useRef(null);

  useEffect(() => {
    // Apply styles only to code blocks within this component's container
    // This runs once on mount and when the container changes
    if (!codeBlockRef.current) return;

    const applyStyles = () => {
      const codeBlocks = codeBlockRef.current?.querySelectorAll("pre.ace-cloud_editor");
      codeBlocks?.forEach((el) => {
        Object.assign(el.style, {
          overflowX: "scroll",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        });
      });
    };

    // Apply styles once after a short delay to ensure CodeView has rendered
    const timeoutId = setTimeout(applyStyles, 50);

    // Only observe this specific container, not the entire document
    const observer = new MutationObserver(applyStyles);
    observer.observe(codeBlockRef.current, { childList: true, subtree: true });

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, [code]); // Re-run when code changes

  return (
    <div ref={codeBlockRef} className="code-block-container" style={{ width: width }}>
      <CodeView
        content={code}
        highlight={languageMap[language] || languageMap.zsh}
        actions={
          <CopyToClipboard
            copyButtonAriaLabel="Copy code"
            copyErrorText="Code failed to copy"
            copySuccessText="Code copied"
            textToCopy={code}
            variant="icon"
          />
        }
      />
    </div>
  );
});
